<template>
  <div>
   
  
    <div class="container search-componnent  px-xl-0 px-3">
 <!-- <SingleSearch :items="searchResult"/> -->

 <SingleSearch :items="searchResult"/>
 
 </div>
 <div class="container d-none">
   <div class="row">
     <div class="col-48 text-start my-4">
    <div class="fw-bold ">Your Search:<span class="text-capitalize text-primary ms-2">{{catTitle}}</span></div>
  </div>
     <div class="col-38">
  
  <div class="row mb-3 text-start">
    <div class="col-25 d-flex flex row align-items-center justify-content-end">
<div class="col fs-3">{{searchResult.length}} Results  </div>
<div class="col primary-service text-decoration-underline d-none">Tips on how to refine your search</div>
    </div>
    <div class="col-23 d-flex flex row align-items-center justify-content-evenly">
    <div class="col-auto me-5">Sort By</div>
   
          <div class="col-auto px-2 border-right border-primary">
            Wanada Certified
          </div>
           <div class="col-auto ">
            <div class="d-inline-flex align-items-center justify-content-center"><img class="svg-icons" alt="explore-by-map" src="@/assets/region.png"/> <span class="
          ms-2">List View</span></div>
          </div>
           <div class="col-auto ">
            <div class="d-inline-flex align-items-center justify-content-center"><img class="svg-icons" alt="explore-by-map" src="@/assets/region.png"/> <span class="
          ms-2">Map View</span></div>
          </div>
          </div>
          
          </div>
   
  </div>

   <div class="col-38 ">
<div class="row pe-6 border-end border-primary">
    <div class="col-48">
  <div  v-for="item in searchResult" :key="item" class="row mb-3 border border-primary category-row position-relative">
   <div class="col-25 me-auto"><div class="primary-service bg-primary text-white mb-4 text-start px-3 py-2">{{item.primaryCategoryLabel}}</div></div>
      <div class="col-25 pb-5">
     
     <div class="details border-end border-primary ps-3 pe-3 text-start">
       <div class="title fs-4 mb-2">{{item.name}}</div>
       <div class=" fs-6 overview mb-3  fw-bold">{{item.subName}}</div>
       <div class="overview">{{item.overview}}</div>
       </div>
   </div>
     <div class="col-23 pe-5 ps-3 pb-5">
      <router-link :to="{name: 'SingleService', params: { title: item.slug }  }"><span class="service-btn btn-primary text-white">></span></router-link>
      <div class="row h-100">
        <div class="col-24 d-flex flex-column text-start align-items-start justify-content-center">
          <div class="s-details"> <div class="overview ">{{item.street}}</div>
      <div class="overview ">{{item.suburb}}</div>
      <div class="overview ">{{item.state}}, {{item.postcode}}</div></div>
      <div class="s-details-connect mt-auto">
        <div class="overview mb-3">{{item.phone1}}</div>
      <div class="overview">{{item.website}}</div>
      </div>
        </div>
        <div class="col-24 ">  <div v-if="item.image" class="service-img mb-2"><img :src="item.image"></div></div>
      </div>
     </div>
   
  </div>
   
</div>
   </div>
 </div>
 <div class="col-10 px-3 filter-col">
    <div class="row mb-5 text-start">
<div class="fw-bold">Filter Results</div>
    </div>

<div class="d-flex flex-column text-start mb-3">
<p>Region </p>
   <select v-model="selectedRegion">
    <option value="undefined" disabled selected>Please Select</option>
   <option v-for="(region, i) in regionUniq" :key="i"  :value="region">{{region}}</option>
  </select>
 
  </div>
    
    
<div class="d-flex flex-column text-start mb-3">
<p>Outreach </p>
  <select v-model="selectedOutreach">
    <option value="undefined" disabled selected>Please Select</option>
    <option value="yes">yes</option>
    <option value="no">no</option>
  </select>
 
  </div>
  <div class="d-flex flex-column text-start mb-3">
<p>Accreditation </p>
  <select v-model="selectedAccreditation">
    <option value="undefined" disabled selected>Please Select</option>
    <option value="yes">yes</option>
    <option value="no">no</option>
  </select>
  </div>


    <button class="filter-btn" @click="search">Search</button>
    <button class="filter-reset-btn" @click="reset">Reset</button>


  </div>
</div>
  </div>
  </div>
</template>

<script>
import SingleSearch from '@/components/SingleSearch';
import { dataPromise } from '@/stores/store.js';
export default {
 
  components: {
    SingleSearch
  },
 data () {
      return {
    myValueCopy: null,
    initialPropValue: null,
    services: [],
    names: [],
    search:'',
    searchResult: [],
     sort: {
        field: '',
        desc: true        
      },
 
 }
 },
  mounted() {

  // var string = this.$route.params.title;
  //       const catTitle = string.split( "-" ).join( " " );
  //       this.catTitle = catTitle
    
    
  },
   methods: {
     reset: function() {
  console.log('reset-clicked');
this.searchResult = this.items
this.selectedOutreach = undefined;
this.selectedRegion = undefined;
this.selectedAccreditation = undefined;
    }, 
      doSort (field){
     this.searchResult.reverse()
    console.log('sort-clicked');
     if(field == this.sort.field){
        this.sort.desc = !this.sort.desc
        	 
      }else{
        this.sort.field = field;
        this.sort.desc = true;
      }
      },
 filteredRegion() {
  
       let filterRegion = this.$route.query.region,
           filterOutreach = this.$route.query.outreach,
           filterAccreditation = this.$route.query.accreditation,
           filterCategory = this.$route.query.category,
           filterSearch = this.$route.query.name,
           filterPostcode = this.$route.query.postcode

      this.searchResult = this.services.filter(function(item) {
        let filtered = true
        
       if (filtered) {
        if (filterSearch && filterSearch.length > 0) {

           let checkSearch = item.overview
           let checkSearchTitle = item.name

        let checkTag = item.tag

            if (!checkSearch.toLowerCase().includes(filterSearch.toLowerCase())) {
              filtered = item.overview ==  filterSearch 
          }
        
        }
       }
        if (filtered) {
        if (filterCategory && filterCategory.length > 0) {
         let checkCategory = item.categoriesValue
         
          if (!checkCategory.includes(filterCategory)) {
          filtered = checkCategory == filterCategory
          }
         
        }
        }
        if (filtered) {
        if (filterRegion && filterRegion.length > 0) {
          filtered = item.region == filterRegion
        }
        }
         if (filtered) {
        if (filterPostcode && filterPostcode.length > 0) {
          filtered = item.postcode == filterPostcode
        }
        }
        if (filtered) {
          if (filterOutreach && filterOutreach.length > 0) {
            filtered = item.outreach == filterOutreach
          }
        }
        if (filtered) {
          if (filterAccreditation && filterAccreditation.length > 0) {
            filtered = item.wanadaCertfication == filterAccreditation
          }
        }
        return filtered
      
      })



let tempRecipes = this.services
    tempRecipes = tempRecipes.filter((item) => {
      return (item.tag.includes(this.$route.query.name) )
    })
    console.log(tempRecipes)
    
let newarr = [...this.searchResult, ...tempRecipes];

this.searchResult = [...new Set(newarr)];

console.log(this.searchResult)
 },

 filteredTags() {


 },
    search: function() {
      // console.log('search-clicked');
      // console.log(this.searchResult);
    
      
    }

  },

computed: {
  //  singleItem: function () {
  //        console.log(this.searchResult)
  //     return this.searchResult.filter( service => {
  //         return service.name.toLowerCase().includes(this.search.toLowerCase())
          
  //       } )
  //  }
},
  
    created () {
// console.log('searchalive')
   dataPromise.then(data => {
  
  this.services = data
  this.filteredRegion();
  
});
    },
}
</script>

<style lang="scss">
// @import '@/assets/app.scss';
</style>
